import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ChevronRight } from 'lucide-react';

export default function PageHeader({ eyebrow, title, subtitle, image, breadcrumbs = [] }) {
  useLocation();
  return (
    <section className="relative overflow-hidden">
      {/* <section className="relative pt-36 pb-20 lg:pb-28 bg-black text-white overflow-hidden"> */}
      {/* {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black" />
        </>
      )} */}
      {/* <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 -left-20 w-[500px] h-[500px] rounded-full bg-[#d42b92]/25 blur-[140px]" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full bg-[#ff5fb1]/15 blur-[140px]" />
      </div> */}

      {/* <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <nav className="flex items-center gap-2 text-xs text-white/55">
          <Link to="/" className="inline-flex items-center gap-1 hover:text-white"><Home className="w-3 h-3" /> Home</Link>
          {breadcrumbs.map((b, i) => (
            <React.Fragment key={i}>
              <ChevronRight className="w-3 h-3 opacity-50" />
              {b.to ? <Link to={b.to} className="hover:text-white">{b.label}</Link> : <span>{b.label}</span>}
            </React.Fragment>
          ))}
        </nav>

        <div className="mt-6">
          {eyebrow && <div className="text-[#ff8ec5] text-xs tracking-[0.3em] uppercase">{eyebrow}</div>}
          <h1 className="mt-3 font-semibold tracking-[-0.03em] text-3xl sm:text-4xl md:text-6xl lg:text-7xl leading-[1.05] break-words">
            {title}
          </h1>
          {subtitle && <p className="mt-5 text-white/70 max-w-2xl text-base sm:text-lg leading-relaxed">{subtitle}</p>}
        </div>
      </div> */}
    </section>
  );
}
